import { aplicarPorcentaje } from '../dinero';
import { comisionLinea, type ReglaComision } from './comisiones';

/** Margen de ganancia: porcentaje guardado ×100 (4000 = 40 %) o monto fijo en centavos. */
export interface Margen {
  tipo: 'porcentaje' | 'fijo';
  valor: number;
}

export function precioVenta(costo: number, margen: Margen): number {
  return costo + (margen.tipo === 'porcentaje' ? aplicarPorcentaje(costo, margen.valor / 100) : margen.valor);
}

/**
 * Lo que deja una pieza vendida: precio al cliente, comisión del vendedor y
 * ganancia del negocio (precio − costo − comisión). Todo en centavos.
 */
export function desglosePieza(costo: number, margen: Margen, comision: ReglaComision): { precio: number; comision: number; ganancia: number } {
  const precio = precioVenta(costo, margen);
  const montoComision = comisionLinea({ total: precio, cantidad: 1 }, comision);
  return { precio, comision: montoComision, ganancia: precio - costo - montoComision };
}

export function disponibleVenta(p: { stockVenta: number; stockReservado: number }): number {
  return Math.max(0, p.stockVenta - p.stockReservado);
}

export type NivelAlerta = 'ok' | 'bajo' | 'agotado';

export function nivelAlerta(p: { stockVenta: number; stockMinimo: number }): NivelAlerta {
  if (p.stockVenta <= 0) return 'agotado';
  return p.stockVenta <= p.stockMinimo ? 'bajo' : 'ok';
}
